module.exports = __webpack_public_path__ + "img/索普-1.8cd04c8b.png";